import { Pipe, PipeTransform } from '@angular/core';
import { TUSpecial } from './tu-special';

@Pipe({
  name: 'searchTUSpecials',
})
export class SearchTUSpecialsPipe implements PipeTransform {
  transform(items: TUSpecial[], searchText: string): TUSpecial[] {
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();

    return items.filter(
      it =>
        it.sku.toLowerCase().includes(searchText) ||
        it.description.toLowerCase().includes(searchText) ||
        it.supplierSKU.toLowerCase().includes(searchText) ||
        // Disable this rule for old data that does not contain class2
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        it.class2?.toLowerCase().includes(searchText) ||
        it.creationBy.toLowerCase().includes(searchText)
    );
  }
}
